export default "__VITE_ASSET__zqozDfHy__"